import Modal from 'react-modal';

Modal.setAppElement('#modal');

export default function ModalWrapper({ children }) {
	return <>
		{children}
	</>;
}